import { render, staticRenderFns } from "./BaseTableEditor.vue?vue&type=template&id=e3e5414c&scoped=true"
import script from "./BaseTableEditor.vue?vue&type=script&lang=js"
export * from "./BaseTableEditor.vue?vue&type=script&lang=js"
import style0 from "./BaseTableEditor.vue?vue&type=style&index=0&id=e3e5414c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e5414c",
  null
  
)

export default component.exports